import React from "react";
import { FormGroup } from "@cofano/cck";
import { Box, Grid2 as Grid } from "@mui/material";
import { Language } from "imports/Utils";
import ShipBayplan from "view/ships/components/bayplan/ShipBayPlan";
import { ShipFromQuery } from "view/ships/ShipDetails";

const ShipHoldDetails = ({ ship }: { ship: ShipFromQuery }) => {

	const bayPlan = ship.bayPlan ? JSON.parse(ship.bayPlan) : {};

	return (
		<React.Fragment>
			<Grid container spacing={3}>
				<Grid size={4}>
					<FormGroup label={Language("BAYPLAN_ROWS")} overflow="hidden">
						{bayPlan.rows || 0}
					</FormGroup>
				</Grid>

				<Grid size={4}>
					<FormGroup label={Language("BAYPLAN_BAYS")} overflow="hidden">
						{bayPlan.bays || 0}
					</FormGroup>
				</Grid>

				<Grid size={4}>
					<FormGroup label={Language("BAYPLAN_TIERS")} overflow="hidden">
						{bayPlan.tiers || 0}
					</FormGroup>
				</Grid>
			</Grid>

			{bayPlan.rows > 0 && bayPlan.bays > 0 && bayPlan.tiers > 0 && (
				<Box mt={2}>
					<ShipBayplan
						rows={bayPlan.rows}
						bays={bayPlan.bays}
						tiers={bayPlan.tiers}
						value={bayPlan.properties} />
				</Box>
			)}
		</React.Fragment>
	);
};

export default ShipHoldDetails;
